<template lang="pug">
.box
  .top
    .top-left
      img.top-left-title(:src="classifyData[index].title")
      .top-left-content {{classifyData[index].titleDetail}}
    .top-right(@click='openVip' v-if="!isSVip") 开通超级会员
    .top-right(@click='openVip' v-if="isSVip") 续费超级会员
  .line
  .introduce
    .introduce-title.title-font 特权介绍
    .introduce-content
      .introduce-content-item(v-for="item in classifyData[index].introduce") {{item}}
  .compare
    .compare-title.title-font 特权对比
    img.compare-content(:src="classifyData[index].compare")
  .show
    .show-title.title-font 特权展示
    img.show-content(:src="classifyData[index].show")
  //- buyVip(@closeVip='closeVip' v-if='showBuyVip')
  VipCenter(:debug="AppMode" :isShow="isShowVipCenter" @closeVipCenter="isShowVipCenter = false" :routeQuery="$route.query")
</template>

<script>
import request from '@/service/login/index';
import vip from '@/service/vip';
import buyVip from '@/components/buyVip.vue';

export default {
  name: 'privilegeClassContent',
  components: {
    buyVip,
  },
  data() {
    return {
      isShowVipCenter: false,
      AppMode: process.env.VUE_APP_MODE !== 'prod',
      showBuyVip: false,
      isLogin: false,
      isSVip: false,
      classifyData: [
        {
          title: require('@/assets/imgs/privilege/documentTranslate/top-title.png'),
          titleDetail: '读论文、英文合同必备神器，方便/快捷/准确',
          introduce: [
            '1.超级会员有效期内，享免费文档翻译100万字符/月，自购买之日起生效，次月月初到账；',
            '2.文档翻译字符用尽，超级会员可购买加量包充值更多翻译字符；',
            '3.文档支持在有道翻译内进行笔记批注、保存及导出，导出文档翻译结果时，不会额外收取费用（即导出与翻译仅收费1次，若导出时未翻译完全文，将扣除剩余文档翻译所需的字符数）；',
          ],
          compare: require('@/assets/imgs/privilege/documentTranslate/compare-content.png'),
          show: require('@/assets/imgs/privilege/documentTranslate/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/documentUpload/top-title.png'),
          titleDetail: '文档上传特权，体验更加便捷',
          introduce: [
            '超级会员上传文档文件大小限40MB以内（支持上传word/pdf/ppt格式内容）。',
          ],
          compare: require('@/assets/imgs/privilege/documentUpload/compare-content.png'),
          show: require('@/assets/imgs/privilege/documentUpload/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/glossary/top-title.png'),
          titleDetail: '专业术语录入，让翻译内容更专业',
          introduce: [
            '超级会员有效期内，可免费录入10万条目术语库内容，若超额将无法继续录入。',
          ],
          compare: require('@/assets/imgs/privilege/glossary/compare-content.png'),
          show: require('@/assets/imgs/privilege/glossary/show-content.png'),
        },
        // --------------
        {
          title: require('@/assets/imgs/privilege/documentExport/top-title.png'),
          titleDetail: '文档导出特权，处理更加便捷',
          introduce: [
            '超级会员上传pdf文档，支持导出译文为word可编辑文档。',
          ],
          compare: require('@/assets/imgs/privilege/documentExport/compare-content.png'),
          show: require('@/assets/imgs/privilege/documentExport/content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/AIBox/top-title.png'),
          titleDetail: '鼠标一划智能改写，一步到位',
          introduce: [
            '超级会员有效期内，可不限次数免费使用所有AIBox功能。',
          ],
          compare: require('@/assets/imgs/privilege/AIBox/compare-content.png'),
          show: require('@/assets/imgs/privilege/AIBox/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/documentAnswer/top-title.png'),
          titleDetail: '你的私人阅读助理',
          introduce: [
            '超级会员有效期内，针对所有上传的PDF文档，可不限次数免费回答。',
          ],
          compare: require('@/assets/imgs/privilege/documentAnswer/compare-content.png'),
          show: require('@/assets/imgs/privilege/documentAnswer/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/wordMap/top-title.png'),
          titleDetail: '思维导图记忆法',
          introduce: [
            '超级会员有效期内，可不限次数免费使用单词图谱功能权益。',
          ],
          compare: require('@/assets/imgs/privilege/wordMap/compare-content.png'),
          show: require('@/assets/imgs/privilege/wordMap/show-content.png'),
        },
        //----------------
        {
          title: require('@/assets/imgs/privilege/picTranslate/top-title.png'),
          titleDetail: '一键上传图片，一键翻译内容',
          introduce: [
            '1.有道翻译支持上传图片，快速提取图片中的文本并翻译；',
            '2.超级会员有效期内，单次可最多批量上传10张图片进行翻译。',
          ],
          compare: require('@/assets/imgs/privilege/picTranslate/compare-content.png'),
          show: require('@/assets/imgs/privilege/picTranslate/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/write/top-title.png'),
          titleDetail: '定位文章优缺点，生成专属报告',
          introduce: [
            '会员有效期内，畅享高级纠错功能，并支持查看更专业、更详尽的写作报告。',
          ],
          compare: require('@/assets/imgs/privilege/write/compare-content.png'),
          show: require('@/assets/imgs/privilege/write/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/audioTranslate/top-title.png'),
          titleDetail: '将音频快速转成文本并翻译',
          introduce: [
            '1.超级会员有效期内，享免费音频翻译30小时/月，自购买之日起生效，次月月初到账。',
            '2.音频翻译时长用尽，超级会员可购买加量包充值更多时长；',
          ],
          compare: require('@/assets/imgs/privilege/audioTranslate/compare-content.png'),
          show: require('@/assets/imgs/privilege/audioTranslate/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/tongchuanTranslate/top-title.png'),
          titleDetail: '会议实时翻译',
          introduce: [
            '1.超级会员有效期内，享免费同传翻译200小时/月，自购买之日起生效，次月月初到账。',
            '2.同传翻译时长用尽，超级会员可购买加量包充值更多时长；',
          ],
          compare: require('@/assets/imgs/privilege/tongchuanTranslate/compare-content.png'),
          show: require('@/assets/imgs/privilege/tongchuanTranslate/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/authorDic/top-title.png'),
          titleDetail: '满足权威、专业查词需求',
          introduce: [
            '1.现已收录《新牛津英汉双解大辞典》，覆盖英式英语、美式英语及日语，释义精要简明，词汇范围广泛而实用，能够满足用户权威、专业的查词需要；',
            '2.超级会员有效期内可在各平台使用以上权威词典。',
          ],
          compare: require('@/assets/imgs/privilege/authorDic/compare-content.png'),
          show: require('@/assets/imgs/privilege/authorDic/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/offlineDic/top-title.png'),
          titleDetail: '金融、科技、医学等专业离线词典全覆盖',
          introduce: [
            '超级会员有效期内可下载各类专业词典离线包，以及超大英汉离线包，离线也可查海量词汇。',
          ],
          compare: require('@/assets/imgs/privilege/offlineDic/compare-content.png'),
          show: require('@/assets/imgs/privilege/offlineDic/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/screenShotTrans/top-title.png'),
          titleDetail: '钉至屏幕功能免费用',
          introduce: [
            '超级会员有效期内，Mac端可免费、不限次数使用截图翻译中的「钉至屏幕」功能，将翻译图片固定在屏幕上，方便进行翻译后的调整与改写。',
          ],
          compare: require('@/assets/imgs/privilege/screenShotTrans/compare-content.png'),
          show: require('@/assets/imgs/privilege/screenShotTrans/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/pureDelAd/top-title.png'),
          titleDetail: '告别广告烦恼，畅享清爽体验',
          introduce: [
            '超级会员有效期内可在全平台享受无广告的使用体验，包括开机、查词翻译等场景均无广告打扰。',
          ],
          compare: require('@/assets/imgs/privilege/pureDelAd/compare-content.png'),
          show: require('@/assets/imgs/privilege/pureDelAd/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/memberId/top-title.png'),
          titleDetail: '彰显尊贵会员体验',
          introduce: [
            '超级会员尊享独特身份标识以及专享角标，全方位彰显尊贵超级会员身份。',
          ],
          compare: require('@/assets/imgs/privilege/memberId/compare-content.png'),
          show: require('@/assets/imgs/privilege/memberId/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/picRecord/top-title.png'),
          titleDetail: '',
          introduce: [
            '超级会员有效期内，可保存500个图片翻译历史记录，支持查看及导出。',
          ],
          compare: require('@/assets/imgs/privilege/picRecord/compare-content.png'),
          show: require('@/assets/imgs/privilege/picRecord/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/tongchuanRecord/top-title.png'),
          titleDetail: '',
          introduce: [
            '超级会员有效期内，可保存100个同传翻译历史记录，支持导出。',
          ],
          compare: require('@/assets/imgs/privilege/tongchuanRecord/compare-content.png'),
          show: require('@/assets/imgs/privilege/tongchuanRecord/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/audioRecord/top-title.png'),
          titleDetail: '',
          introduce: [
            '超级会员有效期内，可保存100个音频翻译历史记录，支持查看及导出。',
          ],
          compare: require('@/assets/imgs/privilege/audioRecord/compare-content.png'),
          show: require('@/assets/imgs/privilege/audioRecord/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/highQuality/top-title.png'),
          titleDetail: '权威外刊解读，拓视野学英语',
          introduce: [
            '1.每天精选1篇权威外刊并由专业团队老师进行解读，每天更新上线，全年更新365篇不间断更新；',
            '2.超级会员有效期内可免费学习所有已更新外刊内容。',
          ],
          compare: require('@/assets/imgs/privilege/highQuality/compare-content.png'),
          show: require('@/assets/imgs/privilege/highQuality/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/originalPrecesion/top-title.png'),
          titleDetail: '团队专业解读，轻松读懂原版书',
          introduce: [
            '1.英语专业内容团队精选原著，针对性进行知识点提炼与导读编写，降低阅读难度；',
            '2.超级会员有效期内可免费学习所有更新精读图书内容。',
          ],
          compare: require('@/assets/imgs/privilege/originalPrecesion/compare-content.png'),
          show: require('@/assets/imgs/privilege/originalPrecesion/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/simpleHome/top-title.png'),
          titleDetail: '体验极简查词的乐趣',
          introduce: [
            '超级会员有效期内可在设置中查看并应用喜爱的简洁查词首页，即可在首页去掉非查词相关元素。',
          ],
          compare: require('@/assets/imgs/privilege/simpleHome/compare-content.png'),
          show: require('@/assets/imgs/privilege/simpleHome/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/pronunciation/top-title.png'),
          titleDetail: '发音智能指导',
          introduce: [
            '1.AI定位发音薄弱音标，通过专业外教发音视频、详细音标发音图文教程，助你打牢完美发音基础；',
            '2.超级会员有效期内可以无次数限制的使用本功能。',
          ],
          compare: require('@/assets/imgs/privilege/pronunciation/compare-content.png'),
          show: require('@/assets/imgs/privilege/pronunciation/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/webTranslate/top-title.png'),
          titleDetail: '轻松浏览外文网页',
          introduce: [
            '1.准确快速的网页翻译体验，原文译文对照的方式，让你对原文理解更加全面；',
            '2.超级会员有效期内无次数限制使用本功能。',
          ],
          compare: require('@/assets/imgs/privilege/webTranslate/compare-content.png'),
          show: require('@/assets/imgs/privilege/webTranslate/show-content.png'),
        },
        {
          title: require('@/assets/imgs/privilege/listeningResources/top-title.png'),
          titleDetail: '精选优质资料',
          introduce: [
            '1.丰富优质的听力学习资料，包括小学、初中、高中、四六级、大学、专四专八、雅思托福、泛听语料等多主题；',
            '2.超级会员有效期内不限次数下载听力栏目，并可免费收听听力资源。',
          ],
          compare: require('@/assets/imgs/privilege/listeningResources/compare-content.png'),
          show: require('@/assets/imgs/privilege/listeningResources/show-content.png'),
        },
      ],
      index: 0,
    };
  },
  mounted() {
    this.getAccountInfo();
  },
  methods: {
    openVip() {
      // this.showBuyVip = true;
      this.isShowVipCenter = true;
    },
    closeVip() {
      this.showBuyVip = false;
    },
    getAccountInfo() {
      request.getAccountInfos().then((res) => {
        if (res.code === 0) {
          this.isLogin = true;
          this.yduserid = res.data.yduserid;
          this.getVipStatus();
        } else {
          this.isLogin = false;
        }
      });
    },
    getVipStatus() {
      const param = {
        imei: '1',
        keyfrom: 'webdict',
        apiversion: '1.0',
        product: '',
      };
      vip.getVipStatus(param).then((res) => {
        this.isSVip = res.svip;
      });
    },
  },
  watch: {
    $route: {
      handler() {
        this.index = +this.$route.hash.substring(1);
        if (this.index < this.$parent.desktopList.length) {
          this.$parent.type = 0;
          this.$parent.selected = this.index;
        } else if (this.index < (this.$parent.desktopList.length + this.$parent.translateList.length)) {
          this.$parent.type = 1;
          this.$parent.selected = this.index - this.$parent.desktopList.length;
        } else {
          this.$parent.type = 2;
          this.$parent.selected = this.index - (this.$parent.desktopList.length + this.$parent.translateList.length);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="stylus">
.box
  padding 20px 40px 40px 40px
  box-sizing border-box
  box-shadow 0px 2px 60px rgba(35, 73, 95, 0.03)
  background #FFFFFF
  border 1px solid #F4F5F7
  border-radius 24px
  .top
    width 100%
    height 98px
    display flex
    justify-content space-between
    align-items center
    .top-left
      .top-left-title
        height 34px
      .top-left-content
        font-family 'Noto Serif SC'
        font-style normal
        font-weight 400
        font-size 16px
        color #AD855F
        opacity 0.7
        line-height 23px
    .top-right
      width 142px
      height 48px
      border-radius 100px
      background-color #593712
      color #FFEFE0
      text-align center
      line-height 48px
      cursor pointer
      font-size 16px
  .line
    width 100%
    border-top 1px #DBB89A dashed
    transform scaleY(0.5)
  .introduce
    margin-top 28px
  .introduce-title
    margin-bottom 16px
  .introduce-content-item
    font-size 14px
    font-family 'PingFang SC'
    line-height 150%
    color #2a2b2e
    margin-bottom 10px
  .compare
    // background-color #ccc
    margin-top 38px
  .compare-title
    margin-bottom 16px
    font-size 18px
    font-family 'PingFang SC'
    color #2A2B2E
  .compare-content
    height 120px
  .show
    margin-top 38px
  .show-title
    margin-bottom 16px
    font-size 18px
    font-family 'PingFang SC'
    color #2A2B2E
  .show-content
    width 924px
  .title-font
    width 72px
    font-family 'PingFang SC'
    font-style normal
    font-weight 600
    font-size 18px
    line-height 25px
</style>
